import { KeenIcon, DefaultTooltip } from '@/components';
import { Can } from '@casl/react';
import { ItemsModal } from '@/pages/billing';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { createRoot } from 'react-dom/client';
import { useAuthContext } from '@/auth';
import { renderMultiAvatars } from '@/utils'
import { ConfirmationModal } from '@/components/modal';
import { useConfirmationModal } from '@/hooks';
import { SelectInput, DateInput, STATUS_INVOICE_OPTIONS } from '@/components/TableFilter'
import { cn } from '@/lib/utils';
import { Navigate, useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import invoiceTemplateService from '@/services/billing/invoice/invoiceTemplateService';
import invoiceService from '@/services/billing/invoice/invoiceService';
import { DefaultInvoiceTemplate } from '@/components'
import companySettings from '@/services/setting/companySettings';
import { useToolbar } from '@/providers/ToolbarProvider';
import { Menu, MenuItem, MenuLink, MenuSub, MenuTitle, MenuArrow } from '@/components/menu';
import { useLanguage } from '@/i18n';

const InvoiceDetails = () => {
    const { id } = useParams();
    const templateId = id;
    const [dataLoading, setDataLoading] = useState(false)
    const [templateData, setTemplateData] = useState(null)
    const [activeTemplate, setActiveTemplate] = useState('');
    const [loading, setLoading] = useState(false);
    const [companyData, setCompanyData] = useState(null)
    const { setConfig } = useToolbar();
    const { isRTL } = useLanguage();

    const renderInvoiceTemplate = (step, data) => {
        console.log('step', step)
        switch (step) {
            case 'matter':
                return <Setup />;
            case 'classic':
                return <Items />;
            case 'clover':
                return <Expense />;
            case 'impact':
                return <FlatFees />;
            case 'lava':
                return <CreateInvoice />;
            case 'postal':
                return <CreateInvoice />;
            default:
                return <DefaultInvoiceTemplate data={data} companyData={companyData} />;

        }

    };

    const getSingleInvoice = async (id) => {
        setDataLoading(true)
        try {
            const { data, status } = await invoiceService.getSingleInvoice(id);
            const { name } = data.invoice_template
            // return console.log(data)
            if(status) {
                setTemplateData(data)
                setActiveTemplate(name)
                console.log('--->',templateData)
            }
        } catch (error) {
            console.error('Error', error)
            toast.error('Failed to fetch Invoice Details.', {
                description: 'An error occurred while fetching invoice details. Please try again later.',
                action: {
                    label: 'Ok',
                },
            });
        } finally {
            setDataLoading(false)
        }
    }

    const getCompanySettings = async () => {
        try {
            setLoading(true);
            const {data, status} = await companySettings.getCompanySettings()
            if(status) {
                setCompanyData(data)
            }
        } catch (error) {
            console.error('Error:', error)
            setLoading(false);
        } finally {
            setLoading(false)
        }
    }

    const handleApproveInvoice = async () => {
        try {
            setLoading(true);
            const {data, status} = await invoiceService.aprroveInvoice(templateId)
            if(status) {
                toast.success('Approved Successfully.', {
                    description: 'Invoice Approved Successfully.',
                    action: {
                        label: 'Ok',
                    },
                });
            }
        } catch (error) {
            console.error('Error:', error)
            toast.error('Failed to approve Invoice.', {
                description: 'An error occurred while approving invoice. Please try again later.',
                action: {
                    label: 'Ok',
                },
            });
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getSingleInvoice(templateId);
        getCompanySettings();
    }, [])

    useEffect(() => {
        setConfig({
          actions: (
            <>  
              {/* <Can I="export" a="contact" ability={ability}> */}
                <button disabled={dataLoading} className="btn btn-xs btn-sm btn-light">
                  <KeenIcon icon="exit-down" />
                  Download as PDF
                </button>
              {/* </Can> */}
              {/* <Can I="export" a="contact" ability={ability}> */}
                <button disabled={dataLoading} onClick={downloadPDF} className="btn btn-xs btn-sm btn-light">
                  <KeenIcon icon="note-2" />
                  Clone Invoice
                </button>
              {/* </Can> */}
              <Menu highlight={true} className="gap-3">
                <MenuItem
                  toggle="dropdown"
                  trigger="hover"
                  dropdownProps={{
                    placement: isRTL() ? 'bottom-end' : 'bottom-start',
                    modifiers: [{ name: 'offset', options: { offset: [0, 0] } }]
                  }}
                  className="border-b-2 border-b-transparent menu-item-active:border-b-primary menu-item-here:border-b-primary"
                >
                  <MenuLink className="btn btn-xs btn-sm btn-light gap-1.5 px-2">
                    <MenuTitle className="text-nowrap ">
                      Edit Status
                    </MenuTitle>
                    <MenuArrow>
                      <KeenIcon icon="down" className="text-2xs text-gray-500" />
                    </MenuArrow>
                  </MenuLink>
                  <MenuSub className="menu-default" rootClassName="py-2 min-w-[200px]">
                    <MenuItem onClick={handleApproveInvoice}>
                      <MenuLink path="#">
                        <MenuTitle>Approve</MenuTitle>
                      </MenuLink>
                    </MenuItem>
                    <MenuItem>
                        <MenuLink path="#">
                            <MenuTitle>Mark as Sent</MenuTitle>
                        </MenuLink>
                    </MenuItem>
                  </MenuSub>
                </MenuItem>
              </Menu>
            </>
          ),
        });
    
        return () => setConfig(null);
    }, []);

    return (
        <>
        {dataLoading && activeTemplate === '' ? (
            <div className='card h-[660px] flex items-center justify-center'>Loading...</div>
        ) : (
            renderInvoiceTemplate(activeTemplate, templateData)
        )}
        </>
    )
}

export { InvoiceDetails }